module.exports = __webpack_public_path__ + "img/fuyi.39c010fa.jpg";